import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import LoadingApp from '../../../components/LoadingApp'
import ModalFeedBack from '../../../components/ModalFeedBack'
import { EnderPostal } from '../../../interfaces/entities/MeuCadastro/EnderPostal'
import { MeuCadastroResponse } from '../../../interfaces/entities/MeuCadastro/MeuCadastroResponse'
import { getMeuCadastro } from '../../../services/BeneficiarioService'
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext'
import { getBenef } from '../../../Store/storages/BeneficiarioStorage'
import useFocus from '../../../utils/hooks/useFocus'
import AdressData from './AdressData'
import BillingData from './BillingData'
import ContactData from './ContactData'
import ContractData from './ContractData'
import PersonalData from './PersonalData'
import { sxMeuCadastroTitle } from './sxProps'
import PageTitle from '../../../components/Accessibility/PageTitle'

const MeuCadastro: React.FC = () => {

  const { fontSizeTitleStyleAccessibility } = useAccessibility();
  const focusRef = useFocus();

  const [registrationData, setRegistrationData] = useState<MeuCadastroResponse>();
  const [editAdressData, setEditAdressData] = useState<boolean>(false);
  const [editBillingData, setEditBillingData] = useState<boolean>(false);
  const [editing, setEditing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const canChangeData = getBenef()?.indAtualizaEnderPostal === 'S';

  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  const openModalSuccess = () => {
    setModalFeedback({
      icon: 'success',
      title: 'Dados salvos',
      subTitle: 'Seus dados foram alterados com sucesso!',
      showButtonModal: false,
      closeAction: closeModalSuccess
    });
  }

  const closeModalSuccess = async () => {
    setModalFeedback(null);
    await fetchDadosCadastrais();
    setEditAdressData(false);
    setEditBillingData(false);
  }

  const fetchDadosCadastrais = async () => {
    setLoading(true);
    const response = await getMeuCadastro();
    if (response?.status === 200) {
      const registrationData = response.data;
      setRegistrationData(registrationData);
    } else {
      console.error(response);
      openModalError('Erro ao consultar dados cadastrais', 'Ocorreu um erro ao consultar os dados, tente novamente em instantes.');
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchDadosCadastrais()
    if (focusRef.current) {
      focusRef.current.focus();
    }
  }, [])

  useEffect(() => {
    setEditing(editAdressData || editBillingData);
  }, [editAdressData, editBillingData])

  const handleEditAdressData = () => {
    setEditAdressData(edit => !edit)
  }

  const getMyRegistrationDescriptionTitle = () => {
    if (editAdressData) {
      return 'Alterar endereço de correspondência';
    } else if (editBillingData) {
      return 'Alterar endereço de cobrança';
    } else {
      return 'Meu cadastro';
    }
  }

  const hasBillingAddress = (enderPostal: EnderPostal[]) => {
    return enderPostal.some((e) => e.tipo === 'COBRANCA');
  };

  return (
    <>
      <div className='meu-cadastro'>
        <div ref={focusRef}>
          <PageTitle text={getMyRegistrationDescriptionTitle()} shouldFocus={false} />
        </div>

        {loading ? <LoadingApp showLoading={loading} /> :
          <>
            {!!registrationData &&
              <>
                {!editing &&
                  <>
                    <ContractData
                      dadosContrato={registrationData.dadosContrato}
                    />
                    <PersonalData nome={registrationData.nome} dadosPessoais={registrationData.dadosPessoais} />
                    <AdressData enderPostal={registrationData.enderPostal} handleEdit={handleEditAdressData} canChangeData={!!canChangeData}
                      openModalSuccessNoButton={openModalSuccess} />
                    {hasBillingAddress(registrationData.enderPostal) &&
                      <BillingData enderPostal={registrationData.enderPostal} canChangeData={!!canChangeData} openModalSuccessNoButton={openModalSuccess} />
                    }
                    <ContactData
                      dadosContato={registrationData.enderComunic}
                      canChangeData={!!canChangeData}
                      openModalFeedBack={openModalError}
                      openModalSuccessNoButton={openModalSuccess} />
                  </>
                }
              </>
            }
          </>
        }
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        showButtonModal={modalFeedback?.showButtonModal}
        handleShowModal={modalFeedback?.closeAction}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default MeuCadastro